import { createContext, useContext, useEffect, useState } from 'react';

const TimerContext = createContext({});

const SECOND = 1000;
const MINUTE = SECOND * 60;
export const TIMER_KEY = '__cryptoys_timer_state';

function getTimeString(milliseconds) {
  const seconds = Math.trunc((milliseconds / SECOND) % 60);
  const minutes = Math.trunc((milliseconds / MINUTE) % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
}

const DEFAULT_TIME = MINUTE * 5;

export function TimerProvider({ children, reservationData }) {
  const [timeLeft, setTimeLeft] = useState();
  const [deadline, setDeadline] = useState(null);

  const [isRunning, setIsRunning] = useState(false);

  const start = () => {
    setDeadline(Date.now() + timeLeft);
    setIsRunning(true);
  };

  const pause = () => {
    setIsRunning(false);
  };

  const reset = (resetMilliseconds = DEFAULT_TIME) => {
    setTimeLeft(resetMilliseconds);
    setDeadline(Date.now() + resetMilliseconds);
  };

  const cleanup = () => {
    window.localStorage.removeItem(TIMER_KEY);
  };

  useEffect(() => {
    if (reservationData) {
      const totalTimeInMilliseconds = reservationData.data.expiresIn * SECOND;
      const sardineTimer = 5 * MINUTE;
      const frontendTimer = totalTimeInMilliseconds - sardineTimer;
      setTimeLeft(frontendTimer);
      setDeadline(Date.now() + frontendTimer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationData]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (timeLeft >= 0) {
        setTimeLeft(deadline - Date.now());
      }
    }, 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deadline, timeLeft]);

  return (
    <TimerContext.Provider
      value={{
        timeLeft: getTimeString(timeLeft),
        isExpired: timeLeft <= 0,
        isRunning,
        cleanup,
        start,
        pause,
        reset
      }}
    >
      {children}
    </TimerContext.Provider>
  );
}

function useTimer() {
  return useContext(TimerContext);
}

export default useTimer;
